var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderContent',{attrs:{"header":"เพิ่มบทความใหม่","img_header":_vm.header_image,"link_back":"contentblog"}}),_c('ContentAddBlogList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }